// @ts-check

import UkkoPlusIcon from '@/components/icons/UkkoPlusIcon.vue'
import {
  mdiAccountMultipleOutline,
  mdiAccountOutline,
  mdiAccountPlusOutline,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiApps,
  mdiArrowCollapseLeft,
  mdiArrowCollapseRight,
  mdiArrowDown,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowRightCircleOutline,
  mdiArrowUp,
  mdiArrowUpCircleOutline,
  mdiAt,
  mdiBackupRestore,
  mdiBankOutline,
  mdiBriefcaseVariantOutline,
  mdiBullhornOutline,
  mdiCalendarBlankOutline,
  mdiCalendarMonthOutline,
  mdiCameraOutline,
  mdiCameraPlusOutline,
  mdiCarOutline,
  mdiCarSide,
  mdiCartOutline,
  mdiCash,
  mdiCashMinus,
  mdiCashPlus,
  mdiChartBar,
  mdiChartPieOutline,
  mdiChartTimelineVariant,
  mdiCheck,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiCircleOutline,
  mdiCircleSlice8,
  mdiClockOutline,
  mdiCloseCircleOutline,
  mdiCloudAlertOutline,
  mdiCloudUploadOutline,
  mdiCogOutline,
  mdiContactlessPayment,
  mdiContentCopy,
  mdiContentSaveOutline,
  mdiCreditCardOutline,
  mdiCubeOutline,
  mdiCurrencyEur,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiEarth,
  mdiEmailAlertOutline,
  mdiEmailSyncOutline,
  mdiEmoticonHappyOutline,
  mdiExclamation,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiFileAlertOutline,
  mdiFileCertificateOutline,
  mdiFileDocumentMultipleOutline,
  mdiFileDocumentOutline,
  mdiFileOutline,
  mdiFilterOutline,
  mdiHelp,
  mdiHelpCircle,
  mdiHelpCircleOutline,
  mdiHomeAccount,
  mdiHomeVariantOutline,
  mdiImageMultipleOutline,
  mdiImageOutline,
  mdiImport,
  mdiInformation,
  mdiInformationOutline,
  mdiInformationSymbol,
  mdiInvoiceTextOutline,
  mdiLightbulbOutline,
  mdiLightningBoltOutline,
  mdiLink,
  mdiLinkVariant,
  mdiLockOutline,
  mdiMagnify,
  mdiMapMarkerOutline,
  mdiMapOutline,
  mdiMinusCircle,
  mdiMinusCircleOutline,
  mdiMonitorAccount,
  mdiOfficeBuildingOutline,
  mdiOpenInNew,
  mdiPackageVariantClosed,
  mdiPaperclip,
  mdiPencil,
  mdiPencilCircle,
  mdiPencilCircleOutline,
  mdiPencilOutline,
  mdiPercentOutline,
  mdiPiggyBankOutline,
  mdiPlusCircle,
  mdiPlusCircleOutline,
  mdiReceiptTextOutline,
  mdiRecordCircle,
  mdiRedo,
  mdiRefresh,
  mdiRotateRight,
  mdiScaleBalance,
  mdiSendCheckOutline,
  mdiShareOutline,
  mdiShieldOutline,
  mdiShieldPlusOutline,
  mdiShovel,
  mdiSort,
  mdiStar,
  mdiStarOutline,
  mdiSwapHorizontal,
  mdiSync,
  mdiTableLarge,
  mdiTableTennis,
  mdiTagOutline,
  mdiTrashCanOutline,
  mdiVibrate,
  mdiViewGalleryOutline
} from '@mdi/js'
import { h } from 'vue'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

const customIcons = {
  ukko_plus: UkkoPlusIcon
}

const custom = {
  component: (/** @type {import('vuetify').IconProps} */ props) =>
    // @ts-expect-error - h() return type doesn't match expected component type
    h(props.tag, [h(customIcons[props.icon], { class: 'v-icon__svg' })])
}

export const icons = {
  defaultSet: 'mdi',
  aliases: {
    apps: mdiApps,
    'contactless-payment': mdiContactlessPayment,
    'pencil-outline': mdiPencilOutline,
    'delete-outline': mdiDeleteOutline,
    'chevron-down': mdiChevronDown,
    'chevron-up': mdiChevronUp,
    'chevron-left': mdiChevronLeft,
    'chevron-right': mdiChevronRight,
    'image-outline': mdiImageOutline,
    'account-outline': mdiAccountOutline,
    'arrow-right': mdiArrowRight,
    'arrow-left': mdiArrowLeft,
    'camera-plus-putline': mdiCameraPlusOutline,
    'view-gallery-outline': mdiViewGalleryOutline,
    'arrow-up': mdiArrowUp,
    'arrow-down': mdiArrowDown,
    at: mdiAt,
    'scale-balance': mdiScaleBalance,
    'invoice-text-outline': mdiInvoiceTextOutline,
    'lightning-bolt-outline': mdiLightningBoltOutline,
    'package-variant-closed': mdiPackageVariantClosed,
    'office-building-outline': mdiOfficeBuildingOutline,
    'arrow-collapse-left': mdiArrowCollapseLeft,
    'arrow-collapse-right': mdiArrowCollapseRight,
    'information-outline': mdiInformationOutline,
    'arrow-up-circle-outline': mdiArrowUpCircleOutline,
    'calendar-blank-outline': mdiCalendarBlankOutline,
    'camera-outline': mdiCameraOutline,
    'car-outline': mdiCarOutline,
    'car-side': mdiCarSide,
    'credit-card-outline': mdiCreditCardOutline,
    'chart-pie-outline': mdiChartPieOutline,
    check: mdiCheck,
    'check-circle-outline': mdiCheckCircleOutline,
    'check-circle': mdiCheckCircle,
    'circle-outline': mdiCircleOutline,
    'pencil-circle': mdiPencilCircle,
    'pencil-circle-outline': mdiPencilCircleOutline,
    pencil: mdiPencil,
    circle: mdiCircle,
    'circle-slice-8': mdiCircleSlice8,
    'arrow-right-circle-outline': mdiArrowRightCircleOutline,
    'clock-outline': mdiClockOutline,
    'alert-outline': mdiAlertOutline,
    'alert-circle-outline': mdiAlertCircleOutline,
    'cloud-alert-outline': mdiCloudAlertOutline,
    'cloud-upload-outline': mdiCloudUploadOutline,
    'cube-outline': mdiCubeOutline,
    'dots-vertical': mdiDotsVertical,
    'home-variant-outline': mdiHomeVariantOutline,
    'currency-eur': mdiCurrencyEur,
    'swap-horizontal': mdiSwapHorizontal,
    exclamation: mdiExclamation,
    'alert-circle': mdiAlertCircle,
    alert: mdiAlert,
    'open-in-new': mdiOpenInNew,
    'map-outline': mdiMapOutline,
    'map-marker-outline': mdiMapMarkerOutline,
    'plus-circle': mdiPlusCircle,
    'minus-circle': mdiMinusCircle,
    'eye-outline': mdiEyeOutline,
    'eye-off-outline': mdiEyeOffOutline,
    star: mdiStar,
    'star-outline': mdiStarOutline,
    'file-outline': mdiFileOutline,
    'file-alert-outline': mdiFileAlertOutline,
    'file-certificate-outline': mdiFileCertificateOutline,
    'file-document-multiple-outline': mdiFileDocumentMultipleOutline,
    'filter-outline': mdiFilterOutline,
    'home-account': mdiHomeAccount,
    'image-multiple-outline': mdiImageMultipleOutline,
    import: mdiImport,
    'information-symbol': mdiInformationSymbol,
    'lightbulb-outline': mdiLightbulbOutline,
    'link-variant': mdiLinkVariant,
    link: mdiLink,
    'lock-outline': mdiLockOutline,
    'monitor-account': mdiMonitorAccount,
    information: mdiInformation,
    'plus-circle-outline': mdiPlusCircleOutline,
    redo: mdiRedo,
    help: mdiHelp,
    'help-circle': mdiHelpCircle,
    'help-circle-outline': mdiHelpCircleOutline,
    'receipt-text-outline': mdiReceiptTextOutline,
    'calendar-month-outline': mdiCalendarMonthOutline,
    magnify: mdiMagnify,
    'bullhorn-outline': mdiBullhornOutline,
    'minus-circle-outline': mdiMinusCircleOutline,
    vibrate: mdiVibrate,
    cash: mdiCash,
    'cash-minus': mdiCashMinus,
    'cash-plus': mdiCashPlus,
    paperclip: mdiPaperclip,
    'percent-outline': mdiPercentOutline,
    'shield-plus-outline': mdiShieldPlusOutline,
    shovel: mdiShovel,
    'emoticon-happy-outline': mdiEmoticonHappyOutline,
    sort: mdiSort,
    sync: mdiSync,
    'table-tennis': mdiTableTennis,
    'tag-outline': mdiTagOutline,
    'close-circle-outline': mdiCloseCircleOutline,
    'trash-can-outline': mdiTrashCanOutline,
    'bank-outline': mdiBankOutline,
    'account-plus-outline': mdiAccountPlusOutline,
    'account-multiple-outline': mdiAccountMultipleOutline,
    refresh: mdiRefresh,
    'email-sync-outline': mdiEmailSyncOutline,
    'email-alert-outline': mdiEmailAlertOutline,
    'content-copy': mdiContentCopy,
    'content-save-outline': mdiContentSaveOutline,
    'shield-outline': mdiShieldOutline,
    'chart-bar': mdiChartBar,
    'chart-timeline-variant': mdiChartTimelineVariant,
    'briefcase-variant-outline': mdiBriefcaseVariantOutline,
    'piggy-bank-outline': mdiPiggyBankOutline,
    'cog-outline': mdiCogOutline,
    'rotate-right': mdiRotateRight,
    earth: mdiEarth,
    'cart-outline': mdiCartOutline,
    'backup-restore': mdiBackupRestore,
    'record-circle': mdiRecordCircle,
    'share-outline': mdiShareOutline,
    'send-check-outline': mdiSendCheckOutline,
    'table-large': mdiTableLarge,
    'file-document-outline': mdiFileDocumentOutline,
    ...aliases
  },
  sets: {
    mdi,
    custom
  }
}
